if (!customElements.get("testimonials-carousel")) {
  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const swiperEl = this.querySelector(".swiper");
      if (!swiperEl) return;

      const options = {
        slidesPerView: 1,
        spaceBetween: 5,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          480: { slidesPerView: 1.5, spaceBetween: 5 },
          768: { slidesPerView: 2.2, spaceBetween: 10 },
          1024: { slidesPerView: 3, spaceBetween: 10 },
        },
      };

      this.swiper = new Swiper(swiperEl, options);
      swiperEl.classList.add("is-initialized");
    }
  }

  customElements.define("testimonials-carousel", TestimonialsCarousel);
}
